module.exports = __webpack_public_path__ + "img/2747cbe10c8adb7a10c12fa01f237403.png";